import { Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router';

import { TableCellCustom } from '@app/components/table';
import { RowActions } from './row-action';
import { IAssets } from '../types';
import { StatusTag } from '@app/components';
import { AssetStatus } from '@app/constants';
import { PATH_DASHBOARD } from '@app/routes/paths';
import { CustomAvatar } from '@app/components/custom-avatar';

interface Props {
  row: IAssets;
  selected: boolean;
  onSelectRow: VoidFunction;
  canAddAsset: string;
}

const AssetsRow = (props: Props) => {
  const { row, canAddAsset } = props;
  let statusValue;
  if (row.status === 'Assigned') {
    statusValue = AssetStatus.Assigned;
  } else if (row.status === 'Repairing') {
    statusValue = AssetStatus.Repairing;
  } else if (row.status === 'Available') {
    statusValue = AssetStatus.Available;
  } else if (row.status === 'Damaged') {
    statusValue = AssetStatus.Damaged;
  } else if (row.status === 'Repaired') {
    statusValue = AssetStatus.Repaired;
  } else {
    statusValue = AssetStatus.Default;
  }

  const WarrantyEnd = () => {
    const purchaseDate = row.purchaseDate;
    const warranty = parseInt(row.warranty, 10);
    const warrantyEndDate = dayjs(purchaseDate, 'DD/MM/YYYY').add(warranty, 'year');
    return warrantyEndDate.format('DD/MM/YYYY');
  };

  const warrantyEnd = WarrantyEnd();
  const navigate = useNavigate();

  const handleDetails = () => {
    navigate(PATH_DASHBOARD.assetsDetail, { state: { id: row.id } });
  };
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  const assetUser = `${row?.users?.firstName} ${row?.users?.lastName}`;
  const userImage = row?.users?.profileImage;

  return (
    <>
      <TableCellCustom flex onClick={handleDetails} align="center" style={{ cursor: 'pointer' }}>
        <Typography variant="body2">{row.id}</Typography>
      </TableCellCustom>
      <TableCellCustom
        sx={{ alignItems: 'center', gap: '9px' }}
        flex
        onClick={handleDetails}
        align="center"
        style={{ cursor: 'pointer' }}
      >
        {row?.users?.firstName ? (
          <Stack style={{ flexDirection: 'row', alignItems: 'center', gap: '9px' }}>
            <CustomAvatar name={assetUser} src={userImage} color={userImage ? 'default' : 'info'} />
            <Typography variant="body2">{assetUser}</Typography>
          </Stack>
        ) : (
          'NA'
        )}
      </TableCellCustom>
      <TableCellCustom flex onClick={handleDetails} align="center" style={{ cursor: 'pointer' }}>
        <Typography variant="body2">
          {row.assetName === 'other' ? row.otherAssetName : row.assetName}
        </Typography>
      </TableCellCustom>
      <TableCellCustom onClick={handleDetails} align="center" style={{ cursor: 'pointer' }}>
        <Typography variant="body2">{row.purchaseDate}</Typography>
      </TableCellCustom>
      <TableCellCustom flex onClick={handleDetails} align="center" style={{ cursor: 'pointer' }}>
        <Typography variant="body2">{row.warranty}</Typography>
      </TableCellCustom>
      <TableCellCustom flex onClick={handleDetails} align="center" style={{ cursor: 'pointer' }}>
        <Typography variant="body2">{warrantyEnd}</Typography>
      </TableCellCustom>
      <TableCellCustom flex onClick={handleDetails} align="center" style={{ cursor: 'pointer' }}>
        <Typography variant="body2">{row.cost}</Typography>
      </TableCellCustom>
      <TableCellCustom flex onClick={handleDetails} align="center" style={{ cursor: 'pointer' }}>
        <StatusTag status={AssetStatus[statusValue]} />
      </TableCellCustom>
      {canAddAsset ? (
        <TableCellCustom align="right" width={50} style={{ cursor: 'pointer' }}>
          <RowActions row={row} />
        </TableCellCustom>
      ) : undefined}
    </>
  );
};

export { AssetsRow };
